import DateLabel from "./parts/DateLabel";
import Image from "./parts/Image";
import PostLink from "./parts/PostLink";

export default function PostBlog({ post }) {

    const postPath = `/post/${post.id}`;

    return (
        <div className="post-blog">

            <DateLabel value={post.creationDate} alignRight={false}></DateLabel>

            <Image src={post.topImage} alt={post.title} />

            <PostLink href={postPath} text={post.title} />

            <div>{post.topContent}</div>

        </div>
    );
}